"use client";

import { useEffect, useState } from "react";
import { X } from "lucide-react";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "src/components/ui/sheet";
import { useStore } from "src/store/store";
import { debounce } from "src/utils/debounce"; // Import the debounce utility
import { AutoCompleteMobile, Option } from "./AutoCompleteMobile";
import { apiFetch } from "src/utils/apiFetch";

const SearchScreen = ({ press }: { press: React.ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  const [value, setValue] = useState<Option>();
  const setSearchOptions = useStore((state) => state.setSearchOptions);
  const [searchType, setSearchType] = useState("catalogue");

  // Debounced version of fetchSuggestions
  const debouncedFetchSuggestions = debounce(async (title: string) => {
    setLoading(true);
    try {
      const endpoint =
        searchType === "catalogue"
          ? `/search-suggestions/products?title=${encodeURIComponent(title)}`
          : `/users/search/suggestions?name=${encodeURIComponent(title)}`;

      const res = await apiFetch(endpoint, "GET");

      const items = res?.data;
      const options = items?.map((item: any) => ({
        value: item?.id,
        label:
          searchType === "catalogue"
            ? item?.title_en
            : item?.first_name + " " + item?.last_name,
        img:
          searchType === "catalogue"
            ? item?.prodImages[0]?.image_url
            : item?.profile_img_url,
      }));
      setSearchOptions(options);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    } finally {
      setLoading(false);
    }
  }, 2000); // 300ms delay

  useEffect(() => {
    setSearchOptions([]);
    debouncedFetchSuggestions(""); // Initial fetch (if needed)

    return () => {
      // Cleanup the debounced function
      debouncedFetchSuggestions.cancel(); // Assuming debounce utility supports cancel
    };
  }, [searchType, setSearchOptions]);

  const searchOptions = useStore((state) => state.searchOptions);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>{press}</SheetTrigger>
      <SheetContent className="min-w-full bg-gray-100">
        <SheetHeader className="relative">
          <SheetTitle className="absolute right-0 top-0">
            <X className="size-6" onClick={() => setOpen(false)} />{" "}
          </SheetTitle>
          <SheetDescription></SheetDescription>
        </SheetHeader>
        <div>
          <div className="h-screen bg-gray-100 p-4">
            {/* Header */}
            <div className="flex items-center justify-start gap-x-3 text-xl font-semibold text-gray-700">
              {/* <Search className="h-6 w-6" /> */}
              {/* <Input
                className="border-none bg-transparent placeholder:text-xl placeholder:font-semibold focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0"
                placeholder="Search"
              /> */}
              <AutoCompleteMobile
                closeSheet={() => setOpen(false)} // ✅ Ensure it's a function
                options={searchOptions}
                emptyMessage="No results."
                placeholder="Search "
                isLoading={isLoading}
                onValueChange={setValue}
                value={value}
                disabled={isDisabled}
                searchType={searchType}
                onInputChange={debouncedFetchSuggestions} // Use the debounced function here
              />
            </div>
            {/* Quick Links */}
            {/* <div className="mt-6">
              <h2 className="text-sm text-gray-500">Quick Links</h2>
              <div className="mt-2 space-y-4">
                {[
                  "If you forgot your Apple Account password",
                  "If you forgot your iPhone passcode, use your Mac or PC to reset it",
                  "If you want to cancel a subscription from Apple",
                  "Update your iPhone or iPad",
                  "Contact Apple Support",
                ].map((text, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-2 text-sm text-gray-700"
                  >
                    <span className="text-lg">→</span>
                    <span className="font-medium">{text}</span>
                  </div>
                ))}
              </div>
            </div> */}
          </div>
        </div>
        <SheetFooter>
          <SheetClose asChild></SheetClose>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};

export default SearchScreen;
